/* The whole card is the name's link target; LinkedIn sits above it. */
.person {
  position: relative;
  display: flex;
  flex-direction: column;
}
/* One treatment for every portrait: shot against white walls, dark studios and red
   curtains, in colour they read as nineteen different photos rather than one team. */
.photo {
  margin-bottom: var(--sp-4);
  border-radius: var(--radius-lg);
  filter: grayscale(1) contrast(1.06);
  transition: filter var(--dur) var(--ease);
}
.photo img {
  object-position: center 22%;
}
/* Colour returns for the one person being pointed at. */
.person:hover .photo,
.person:focus-within .photo {
  filter: none;
}
.name {
  font-size: var(--fs-lg);
  line-height: var(--lh-snug);
}
.nameLink {
  color: var(--text-strong);
  text-decoration: none;
}
.nameLink::after {
  content: "";
  position: absolute;
  inset: 0;
}
.nameLink:hover,
.person:hover .nameLink {
  color: var(--accent-text);
}
.role {
  margin: var(--sp-1) 0 0;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.location {
  margin: var(--sp-1) 0 0;
  font-size: var(--fs-sm);
  color: var(--text);
}
.bio {
  margin: var(--sp-4) 0 0;
  color: var(--text);
}
.linkedin {
  position: relative;
  z-index: 1;
  align-self: flex-start;
  margin-top: var(--sp-3);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-strong);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
}
.linkedin:hover {
  color: var(--accent-text);
}

/* Leaders: their one-line bio. Portraits are held near the size of their originals (the
   leaders' are 400px, most others 200px): stretched across a 430px card, a sharp screen
   showed every pixel. */
.lead .photo {
  max-width: 15rem;
}
.member .photo {
  max-width: 12rem;
}
.lead .name {
  font-size: var(--fs-xl);
}
.lead .role {
  font-size: var(--fs-md);
}

/* Compact: face, name and role, several to a row. */
.compact .photo {
  margin-bottom: var(--sp-3);
  border-radius: 50%;
}
.compact .name {
  font-size: var(--fs-md);
}
/* One line per name: a longer name (Aleksey Smolenskyi) runs a little into the gap, which
   from tablet width up is always wider than the overflow. Phones may still wrap. */
@media (min-width: 48rem) {
  .compact .name {
    white-space: nowrap;
  }
}

/* ---------- Phones: a leader's portrait beside the text ---------- */
@media (max-width: 47.99rem) {
  .lead {
    display: grid;
    grid-template-columns: 6.5rem minmax(0, 1fr);
    column-gap: var(--sp-4);
    align-content: start;
  }
  .lead .photo {
    grid-row: 1 / span 5;
    margin-bottom: 0;
  }
  .lead > :not(.photo) {
    grid-column: 2;
  }
  .lead .bio {
    margin-top: var(--sp-2);
    font-size: var(--fs-sm);
  }
}
